/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class InfectedExcludePath {
  /**
  * The unique identifier of the path exclusion
  */
  'id': string;
  /**
  * The path to exclude from ransomware detection
  */
  'path': string;
  /**
  * The resource ID for which to use the path exclusion if resource level
  */
  'providerResourceId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "path",
      "baseName": "path",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerResourceId",
      "baseName": "providerResourceId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return InfectedExcludePath.attributeTypeMap;
  }

  public constructor() {
  }
}

